import { AlphaKCircleIcon } from './AlphaKCircleIcon';

/**
 * author: Contributors
 * id 1F260841-CE76-48D8-BACE-8935459D850E
 * name alpha-k-circle
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-k-circle.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterKCircleIcon = AlphaKCircleIcon;
export default LetterKCircleIcon